import React from 'react'
import posed, { PoseGroup} from 'react-pose'
import styled from 'styled-components'
import { navigate } from '@reach/router';
import { IconContext } from "react-icons";
import { FiChevronDown } from "react-icons/fi";

const ButtonPose = posed.button({
  enter: {
    y: -20,
    opacity: 1
  },
  exit: {
    y: 0,
    opacity: 0
  },
  bounce: {
    y: -10
  },
  unbounce: {
    y: -20
  }
});

const ButtonScroll = styled(ButtonPose)`
  position: absolute;
  bottom: 20px;
  left: 20px;
  cursor: pointer;
  z-index: 100;
  color: white;
  background: white;
  height: 3em;
  width: 3em;
  @media (min-width: 1024px) {
    position: fixed;
  }
`

class Button extends React.Component {
  state = { isVisible: false, bounce: false };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isVisible: !this.state.isVisible
      });

      setTimeout(() => {
        setInterval(() => {
          this.setState({
            bounce: !this.state.bounce
          });
        }, 800);
      }, 1500);

    }, 1500);

  }

  onClick = (e) => {
    const { scrollTo } = this.props
    navigate(scrollTo);
  }

  render() {
    const { isVisible, bounce } = this.state;

    return(
      <PoseGroup>
        {isVisible ?
          <IconContext.Provider key="scroll" value={{ color: "#2a2a2a", className: "scroll-icon", size: "3em" }}>
            <ButtonScroll pose={bounce ? 'bounce' : 'unbounce'} onClick={this.onClick} className="hidden lg:block">
              <FiChevronDown/>
            </ButtonScroll>
          </IconContext.Provider>
          : null
        }
      </PoseGroup>
    )
  }
}

export default Button
